import React from "react";

/**
 * Silent error boundary for peripheral shell pieces (sidebar sections, header
 * widgets, banners, bottom nav). A crash in one of these must not tear down
 * the dashboard shell — it just hides that piece and lets the rest keep
 * working. Errors are logged so we can fix the root cause without users ever
 * seeing a blank white screen.
 *
 * Prefer this over the full-screen ErrorBoundary for anything that is not the
 * page's main content.
 */
class SafeShellPart extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error(`[SafeShellPart:${this.props.label || "unknown"}]`, error, info?.componentStack);
    try {
      if (window?.posthog?.capture) {
        window.posthog.capture("shell_part_error", {
          label: this.props.label || "unknown",
          message: String(error?.message || error),
          stack: String(error?.stack || "").slice(0, 2000),
        });
      }
    } catch (_) { /* ignored */ }
  }
  render() {
    if (this.state.hasError) return this.props.fallback ?? null;
    return this.props.children;
  }
}

export default SafeShellPart;
